(function () {
  document.addEventListener('DOMContentLoaded', function () {

    const cache = {};
    const MIN_LENGTH = 2;
    const LIMIT = 8;

    async function fetchResults(query) {
      const key = query.toLowerCase();
      if (cache[key]) return cache[key];

      const res = await fetch(
        `${routes.predictive_search_url}?q=${encodeURIComponent(query)}&section_id=predictive-search`
      );

      if (!res.ok) return [];

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const items = [];
      const productItems = doc.querySelectorAll(
        '#predictive-search-results-products-list li'
      );

      productItems.forEach(li => {
        if (items.length >= LIMIT) return;

        const titleEl = li.querySelector('.card__heading');
        const imgEl = li.querySelector('img');
        const linkEl = li.querySelector('a[href*="?variant="]');

        if (!linkEl) return;

        const href = linkEl.getAttribute('href');
        const match = href.match(/variant=(\d+)/);
        if (!match) return;

        const variantId = match[1];
        const skuEl = li.querySelector('[data-sku]');

        const handleMatch = href.match(/\/products\/([^/?#]+)/);
        items.push({
          title: titleEl ? titleEl.textContent.trim() : '',
          image: imgEl ? imgEl.src : '',
          variantId: variantId,
          handle: handleMatch ? handleMatch[1] : ''
        });
      });

      cache[key] = items;
      return items;
    }

    function setupInput(input) {
      const wrapper = input.closest('.sample-search-wrapper');
      if (!wrapper) return;

      const resultsEl = wrapper.querySelector('.sample-search-results');
      if (!resultsEl) return;

      let timer;

      function hide() {
        resultsEl.style.display = 'none';
      }

      function render(items) {
        if (!items.length) {
          resultsEl.innerHTML = '<li class="sample-search-no-results">Geen resultaten</li>';
          resultsEl.style.display = 'block';
          return;
        }

        resultsEl.innerHTML = items.map(item => `
          <li class="sample-search-item" data-variant="${item.variantId}" data-handle="${item.handle}">
            <div class="sample-search-item-inner">
              ${item.image ? `<img src="${item.image}" class="sample-search-img">` : `<div class="sample-search-img sample-search-img--placeholder"></div>`}
              <div class="sample-search-info">
                <div class="sample-search-title">${item.title}</div>
                <div class="sample-search-sku">klik om te selecteren</div>
              </div>
            </div>
          </li>
        `).join('');

        resultsEl.style.display = 'block';

        resultsEl.querySelectorAll('.sample-search-item').forEach(el => {
          el.addEventListener('click', () => {
            input.value = el.dataset.variant;
            hide();
            // WD: product-handle bewaren en de huismerk-controle in sample-form.liquid laten lopen
            input.dataset.wdHandle = el.dataset.handle || '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }

      input.addEventListener('input', e => {
        clearTimeout(timer);
        timer = setTimeout(async () => {
          const q = e.target.value.trim();
          if (q.length < MIN_LENGTH) {
            hide();
            return;
          }

          resultsEl.innerHTML = '<li class="sample-search-loading">Zoeken...</li>';
          resultsEl.style.display = 'block';

          const results = await fetchResults(q);
          render(results);
        }, 200);
      });

      input.addEventListener('blur', () => {
        setTimeout(hide, 200);
      });
    }

    document.querySelectorAll('.sample-search-input').forEach(setupInput);

  });
})();
